import * as React from 'react';
import styled from 'styled-components';
import { Mobile } from './components/Mobile';
import { InlineMobile } from './components/InlineMobile';
import { Web } from './components/Web';
import Toast from './components/Toast';
import { dialogSize, listenORIChange } from '@/service/jsbridge';
import { searchObj, isNative, isMobile } from '@/utils/constants';
import { getElementRect } from '@/utils/utils';
import { getBaseRem } from '@/utils/rem';

const { useEffect, useRef, useState } = React;

const app_env = searchObj['os_type'] === '0' || searchObj['os_type'] === '1';

interface Props {
  onClose: () => void;
  onSubmit: (value: string) => void;
  onSuccess: () => void;
  resize: () => void;
  theme: any;
  text: IObj;
  isWhirl: boolean;
  orientation: number;
}

// isNative && props.orientation的逻辑是为了修复在客户端横屏情况下置background半透明的话，切换到反馈切换时，因为高度不一致会出现上下边界阴影
// isNative && props.isWhirl 是为了处理旋转验证码在移动端切换反馈页面时明显的抖动效果（上下有个半透明的边）
const Mask = styled.div<{
  orientation?: number | string;
  isWhirl: boolean;
}>`
  font-size: unset;
  div,
  a,
  span,
  svg,
  img {
    font-size: unset;
  }
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999999;
  ${(props) =>
    (isNative && props.orientation == 1) || (isNative && props.isWhirl)
      ? ''
      : 'background: rgba(0, 0, 0, 0.5);'}
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default (props: Props) => {
  const {
    onSubmit,
    text,
    onSuccess,
    isWhirl,
    theme,
    orientation,
    resize,
  } = props;
  const [ori, setOri] = useState(orientation);
  const feedbackRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(!app_env);
  const [selected, setSelected] = useState('');
  let timeout: number;
  const handleSubmit = (selected: string) => {
    if (!selected) return;
    onSubmit(selected);
    if (isMobile) {
      Toast.mobileAlert(text.feedback_success, onSuccess);
    } else {
      Toast.webAlert(text.feedback_success);
    }
  };
  const handleChange = (value: string) => {
    setSelected(value);
  };
  useEffect(() => {
    if (app_env && feedbackRef.current) {
      if (+ori === 1) {
        const baseRem = getBaseRem();
        dialogSize({
          w: 520 * (baseRem / 100),
          h: 266 * (baseRem / 100),
        });
      } else {
        const rect = getElementRect(feedbackRef.current);
        dialogSize(rect);
      }
      timeout = setTimeout(() => {
        setShow(true);
      }, 300);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  });
  useEffect(() => {
    if (app_env) {
      return listenORIChange<{
        orientation: number;
      }>(({ orientation }) => {
        window.captchaOptions.orientation = orientation;
        resize();
        setOri(orientation);
      });
    }
  }, [resize]);
  let wrapper;
  if (isMobile) {
    if (Number(ori) === 1) {
      wrapper = (
        <InlineMobile
          {...props}
          selected={selected}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      );
    } else {
      wrapper = (
        <Mobile
          {...props}
          selected={selected}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      );
    }
  } else {
    wrapper = (
      <Web
        {...props}
        selected={selected}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    );
  }
  return (
    <Mask
      className="verify-captcha-feedback-mask"
      orientation={ori}
      isWhirl={isWhirl}
    >
      <div
        style={app_env ? { background: theme.feedbackBgColor } : {}}
        ref={feedbackRef}
      >
        <div style={{ visibility: show ? 'visible' : 'hidden' }}>{wrapper}</div>
      </div>
    </Mask>
  );
};
